import {_} from 'lodash';
import * as ko from "knockout"
import {IExportQueue, IMessageData, IObjectData, IRouteDefinitionParams, ITableColumn} from "../../index"
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker"
import {createErrorMessage} from "../../util/misc"
import {nsRoute} from "../../util/route"
import {ISortableTableParams} from "../sortable/index";
import {convertFromServerString} from "../../util/datetime";
import {REQUEST_MESSAGE} from "../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import export_queueHtml from './export-queue.html?raw';

export let template = export_queueHtml

interface ICustomExportQueue extends IExportQueue {
    $registeredby: KnockoutObservable<IObjectData>
}

export class viewModel extends ParsedRouteDataDecorator {
    private original!: IObjectData
    private data: KnockoutObservableArray<ICustomExportQueue> = ko.observableArray<ICustomExportQueue>([])
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null)
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private readonly tableColumns: ITableColumn<ICustomExportQueue>[] = [
        {
            key: 'id',
            sort: true,
        }, {
            key: 'action',
            label: 'subject',
            sort: true,
        }, {
            key: 'registered',
            sort: true,
        }, {
            key: 'exported',
            sort: true,
        }, {
            key: 'registeredby',
            sort: true,
            component: obj => ({
                name: 'component/variable/object-by-id',
                params: {
                    callback: (o: IObjectData) => obj.$registeredby(o),
                    id: obj.registeredby,
                },
            }),
        }, {
            key: 'targetsystem',
            sort: true,
        }, {
            key: 'target',
            sort: true
        }, {
            key: 'targetattribute',
            label: 'attribute',
            sort: true
        }, {
            key: 'value',
            sort: true,
        }, {
            key: 'retrycount',
            sort: true,
        }, {
            key: 'lasterror',
            label: 'error message',
            getCellCss: () => 'text-danger',
            sort: true,
        },
    ]
    private readonly tableParams: ISortableTableParams<ICustomExportQueue> = {
        asc: ko.observable(false),
        TABLE: this.tableColumns,
        data: this.data,
        getCellSortValue: (key, val, item) => {
            let firstSortVal: any
            const secondSortVal = item.id
            switch (key) {
                case 'registered':
                case 'exported': {
                    if (key in item) {
                        firstSortVal = val ? convertFromServerString(String(val)).unix() : 0
                        break
                    } else {
                        firstSortVal = 0
                        break
                    }
                }
                case 'registeredby':
                    firstSortVal = item.$registeredby() ?? item.registeredby
                    break
                default:
                    firstSortVal = val
                    break
            }
            return [firstSortVal, secondSortVal]
        },
        sortcol: ko.observable<keyof ICustomExportQueue>('registered' as keyof ICustomExportQueue),
    }


    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.init()
    }

    private init(): Promise<any> {
        this.isReady(false)
        this.messageData({message: REQUEST_MESSAGE})
        return this.__requestRouteData!
            .request()
            .then((data: IObjectData[]) => {
                const original = data[0];
                if (!original) {
                    return;
                }
                this.original = original
                const customExportQueue = (this.original.exportqueue ?? []).map(o => {
                    return _.defaultsDeep({$registeredby: ko.observable(null)}, o)
                });
                this.data(customExportQueue)
                this.tableParams.data = this.data
                this.messageData(null)
                this.isReady(true)
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })

    }

    override dispose() {
        super.dispose()
        this.kosub.unsuscribeAll()
        this.__requestRouteData?.abort()
    }
}
